// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8967eb18","977":"93af7093"}[chunkId] + ".chunk.js";
};